import StorehouseInput from "@/widgets/Inputs/StorehouseInput.vue";

export default {
	data() {
		return {
			filterStorehouse: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterStorehouse._id": {
			handler(val) {
				// let fieldName = "warehouse";
				// if (val !== "") {
				// 	this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				// } else {
				// 	this.$delete(this.kvFilter, fieldName);
				// }
			},
			immediate: true
		}
	},
	components: {
		StorehouseInput
	}
};
